import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "./PageProfile.css";

import {
  FaArrowLeft,
  FaChevronRight,
  FaBell,
  FaCommentDots,
  FaCalendarAlt,
  FaHeart,
  FaStore,
  FaInfoCircle,
} from "react-icons/fa";

function PageProfile() {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");

  useEffect(() => {
    const storedMobile = localStorage.getItem("userMobile");
    if (storedMobile) {
      setMobile(storedMobile);
    }
  }, []);

  const handleLogout = () => {
    localStorage.setItem("isLoggedIn", "false");
    localStorage.removeItem("userMobile");
    navigate("/");
  };

  // ===========================
  // Navigation Functions
  // (Update routes later)
  // ===========================

  const handleBookings = () => {
    navigate("/my-bookings");
  };

  const handleFavouriteBrands = () => {
    navigate("/favorite-brands");
  };

  const handleFavouriteOutlets = () => {
    navigate("/favorite-outlets");
  };

  const handleNotification = () => {
    navigate("/notifications");
  };

  const handleFeedback = () => {
    navigate("/feedback");
  };

  const handleAboutUs = () => {
    navigate("/about-us");
  };

  return (
    <div className="profile-page">
      {/* Header */}
      <div className="profile-header">
        <button
          className="back-btn"
          onClick={() => navigate("/shop")}
        >
          <FaArrowLeft />
        </button>

        <div className="profile-info">
          <div className="profile-avatar">
            <div className="avatar-icon">👤</div>
          </div>

          <h2 className="profile-head">Your Account</h2>

          <p className="profile-number">{mobile}</p>
        </div>
      </div>

      {/* Menu Card */}

      <div className="info-card">

        {/* My Bookings */}

        <div
          className="info-row"
          onClick={handleBookings}
        >
          <div className="icon-box">
            <FaCalendarAlt />
          </div>

          <div className="text-box">
            <h4>My Bookings</h4>
            <p>View your bookings</p>
          </div>

          <FaChevronRight className="arrow-icon" />
        </div>

        <div className="divider" />

        {/* Favourite Brands */}

        <div
          className="info-row"
          onClick={handleFavouriteBrands}
        >
          <div className="icon-box">
            <FaHeart />
          </div>

          <div className="text-box">
            <h4>My Favourite Brands</h4>
            <p>Your saved brands</p>
          </div>

          <FaChevronRight className="arrow-icon" />
        </div>

        <div className="divider" />

        {/* Favourite Outlets */}

        <div
          className="info-row"
          onClick={handleFavouriteOutlets}
        >
          <div className="icon-box">
            <FaStore />
          </div>

          <div className="text-box">
            <h4>My Favourite Outlets</h4>
            <p>Your saved outlets</p>
          </div>

          <FaChevronRight className="arrow-icon" />
        </div>

        <div className="divider" />

        {/* Notifications */}

        <div
          className="info-row"
          onClick={handleNotification}
        >
          <div className="icon-box">
            <FaBell />
          </div>

          <div className="text-box">
            <h4>Notification</h4>
            <p>Stock notifications & updates</p>
          </div>

          <FaChevronRight className="arrow-icon" />
        </div>

        <div className="divider" />

        {/* Feedback */}

        <div
          className="info-row"
          onClick={handleFeedback}
        >
          <div className="icon-box">
            <FaCommentDots />
          </div>

          <div className="text-box">
            <h4>Feedback</h4>
            <p>Share your thoughts with us</p>
          </div>

          <FaChevronRight className="arrow-icon" />
        </div>

        <div className="divider" />

        {/* About Us */}

        <div
          className="info-row"
          onClick={handleAboutUs}
        >
          <div className="icon-box">
            <FaInfoCircle />
          </div>

          <div className="text-box">
            <h4>About Us</h4>
            <p>Know more about us</p>
          </div>

          <FaChevronRight className="arrow-icon" />
        </div>

      </div>

      {/* Logout */}

      <div
        className="logout-box"
        onClick={handleLogout}
      >
        <strong>Logout</strong>
      </div>

    </div>
  );
}

export default PageProfile;